import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfa3',
  templateUrl: './mfa3.component.html',
  styleUrls: ['./mfa3.component.scss']
})
export class Mfa3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
